<template>
	<div class="api_access">
		<h1 class="doc_main_h1">
			鉴权方案
		</h1>
		<p class="doc_main_p">
			SKEye开放平台通过鉴权签名串来验证请求的合法性，客户端需具备合法签名后才可使用SKEye接口。密钥的获取和鉴权签名串的生成方法如下：
		</p>
		<h3 class="doc_main_h3">
			1.申请应用密钥
		</h3>
		<p class="doc_main_p">
			（1）登录www.sk-ai.com，注册账号并登录到控制台页面。
		</p>
		<p class="doc_main_p">
			（2）创建应用，获取到系统自动分配的一对密钥（API Key和API Secret）。
		</p>
		<p class="doc_main_p">
			（3）如果已创建应用，点开应用列表，即可查看应用的密钥信息。
		</p>
		<h3 class="doc_main_h3">
			2.签名示例
		</h3>
		<p class="doc_main_p">
			（1）鉴权签名串生成后放入https请求的头部,并以Authorization为key；SKEye各平台SDK里含有完整的签名流程，开发者只需在初始化SDK的时候传入API Key和API Secret即可。
		</p>
		<p class="doc_main_p doc_main_link">
			（2）我们提供以下几种版本的SDK：
			<a href="https://github.com/interjoy/SKEye-iOS-SDK">iOS</a>，
			<a href="https://github.com/interjoy/SKEye-Android-SDK">Android</a>，
			<a href="https://github.com/interjoy/SKEye-Windows-SDK">Windows</a>，
			<a href="https://github.com/interjoy/SKEye-Linux-SDK">Linux</a>，
			<a href="https://github.com/interjoy/SKEye-Unity-SDK.git">Unity</a>。
		</p>
		<h3 class="doc_main_h3">
			3.签名算法
		</h3>
		<p class="doc_main_p">
			如果你要自己实现签名算法，以水果识别接口说明如下：
		</p>
		<p class="doc_main_p">
			水果识别接口的URL为 https://api.sk-ai.com/fruits
		</p>
		<p class="doc_main_p">
			（1）假设通过步骤1，你获取的密钥信息如下：
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">API Key = "15832dbe37310893213a2c490ce63a0e";
API Secret = "e424d05860ef64ce5840606388099ef4";</code></pre>
		<p class="doc_main_p">
			（2）拼接有效的签名串：
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">api_key + "&" + service_name + "&" + time</code></pre>
		<p class="doc_main_p">
			api_key为用户的API Key
		</p>
		<p class="doc_main_p">
			service_name为用户要使用的服务名称
		</p>
		<p class="doc_main_p">
			time为当前时间戳，长度10位，单位为秒
		</p>
		<p class="doc_main_p">
			拼接有效签名串的结果,下文称之为oss（Orignal Signature String）
		</p>
		<p class="doc_main_p">
			（3）生成签名串：
		</p>
		<p class="doc_main_p">
			（3-1）API Secret与原始签名串拼接
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">api_secret + oss</code></pre>
		<p class="doc_main_p">
			api_secret为用户的API Secret
		</p>
		<p class="doc_main_p">
			拼接后的结果，下文称之为secret_oss
		</p>
		<p class="doc_main_p">
			（3-2）使用SHA256 算法对secret_oss进行加密签名
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">Sha256(secret_oss)</code></pre>
		<p class="doc_main_p">
			（3-3）加密签名串（sha_signature）和原始签名串（oss）进行拼接
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">sha_signature + oss</code></pre>
		<p class="doc_main_p">拼接后的结果，下文称之为signature</p>
		<p class="doc_main_p">
			（3-4）签名串需要使用 Base64 编码
		</p>
		<p class="doc_main_p">根据签名方法signature= Base64(SHA256(API Secret + oss) + oss)，其中API Secret为步骤1中获取，oss为3.2中拼接好的签名串，对(API Secret + oss)使用HA256算法进行加密签名，然后将oss附加到签名结果的末尾，再进行Base64编码，得到最终的signature。 注：此处使用的是标准的Base64编码，不是urlsafe的Base64编码，请注意。 以 Android 语言为例,其他语言参见SDK下载链接。</p>
		<pre class="doc_main_pre"><code class="doc_main_code">API Key = "15832dbe37310893213a2c490ce63a0e";
API Secret = "e424d05860ef64ce5840606388099ef4";
service_name = "fruits";
oss = "15832dbe37310893213a2c490ce63a0e&fruits&5254122985”
secret_oss = "e424d05860ef64ce5840606388099ef4"+"15832dbe37310893213a2c490ce63a0e&fruits&5254122985"
sha_signature = new SHA256Encrypt().bin2hex(secret_oss);
signature = sha_signature + oss;
signature = Base64.encodeToString(signature.getBytes(), Base64.DEFAULT);</code></pre>
		<p class="doc_main_p">注意：其它程序设计语言的鉴权签名生成过程,与上述过程一致。</p>
		<p class="doc_main_p">
			（4）使用签名串：
		</p>
		<pre class="doc_main_pre"><code class="doc_main_code">//调用url接口，使用“水果识别服务”进行图片识别
service_name = "fruits";
image_url = "http://img.mp.itc.cn/upload/20170720/c26a820ce52d4cb59813ca285642197e_th.jpg";
//请求数据是字符串格式，注意本地图片数据/图片url都需要进行bas64编码
post_data = "service_name" = "fruits"+"&"+"image_url"=Base64(image_url);
device_info格式："<设备唯一号|系统版本号|设备型号|SDK版本号|程序包名>"
（以Android平台为例）
post_data = "device_info" = 
"< dwefwedwed221|Android5.0|M3note|V1.0.0|com.interjoy.skeyesdk>"+"&"+"image_url" = 
"aHR0cDovL3d3dy5zay1haS5jb20vUHVibGljL29iamVjdHNfYmlnL29iamVjdHNfdGVzdF8yNy5qcGc="
//生成的鉴权签名串放在请求头的Authorization字段里面
connection.setRequestProperty("Authorization", signature);
//向服务器发送请求
outputStream.write(postData.getBytes("utf-8"));</code></pre>
	</div>
</template>
<script>
	export default{
		data(){
			return{

			}
		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
</style>


// WEBPACK FOOTER //
// src/views/documents/guide/userService.vue